import querystring from "querystring";

import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { head } from "lodash";
import { shape } from "prop-types";

import { ContactSellersAgentCTA } from "src/features/listing-agent-contact";
import listingProps from "src/shared/utilities/graphql/listingProps";

import analytics from "../../utilities/analytics";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import useReducerActions from "../../utilities/useReducerActions";
import * as S from "./styled";

const ContactFormFooter = ({ listing }) => {
  const {
    contactFormType,
    expertsApiUuid,
    listingId,
    showListingAgentContactForm
  } = useFeatureState();
  const {
    dispatchResetContactFormType,
    dispatchSetContactFormType
  } = useReducerActions();

  const handleContactSellersAgent = () => {
    analytics({
      isHdp: true,
      label: "agent_profile"
    });
  };

  const listingAgentQuery = querystring.stringify({
    ea: "pa",
    for_hdp: true,
    pa: `sale_${listing?.id}`
  });

  const listingAgentProfile = head(listing?.contacts || [])?.profile;
  const listingAgentUrl = `${listingAgentProfile?.url}?${listingAgentQuery}`;

  return (
    <S.Footer>
      <Text type="disclaimer">
        By pressing Send Message, you agree that StreetEasy and real estate
        professionals may call/text you about your inquiry, which may involve
        use of automated means and prerecorded/artificial voices. You don&apos;t
        need to consent as a condition of buying any property, goods or
        services. Message/data rates may apply.
        <br /> <br />
        You also agree to our{" "}
        <S.TermsLink
          href="https://www.zillow.com/z/corp/terms/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms of Use
        </S.TermsLink>
        .
      </Text>
      {listing && listingAgentProfile ? (
        <>
          <S.Separator />
          {showListingAgentContactForm ? (
            <ContactSellersAgentCTA
              closeHostDrawer={dispatchResetContactFormType}
              expertsApiUuid={expertsApiUuid}
              fromSource="expert_hdp"
              listingId={listingId}
              openHostDrawer={() => {
                dispatchSetContactFormType(contactFormType);
              }}
            />
          ) : (
            <S.HdpTerms>
              If you&apos;d like, you may{" "}
              <S.HdpTermsLink
                href={listingAgentUrl}
                onClick={handleContactSellersAgent}
                target="_blank"
              >
                contact the seller&apos;s agent
              </S.HdpTermsLink>
            </S.HdpTerms>
          )}
        </>
      ) : null}
    </S.Footer>
  );
};

ContactFormFooter.propTypes = {
  listing: shape(listingProps)
};

ContactFormFooter.defaultProps = {
  listing: null
};

export default ContactFormFooter;
